module.exports = __webpack_public_path__ + "img/interact-teacher-bg1_new.096fb32d.png";